import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { getJournalById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";

const ViewJournal = () => {
  const navigate = useNavigate();
  const param = useParams();
  const journal_id = param.r_id;
  const [Journals, setJournals] = useState([]);

  const creditCol = (props) => (
    <div>{props.type_id === 902 ? formatCurrency(props.amount) : `-`}</div>
  );
  const debitCol = (props) => (
    <div>{props.type_id === 901 ? formatCurrency(props.amount) : `-`}</div>
  );

  const customersGrid = [
    {
      field: "account",
      headerText: "Account",
      width: "110",
      textAlign: "left",
    },
    {
      headerText: "Credit",
      template: creditCol,
      width: "100",
      textAlign: "right",
    },
    {
      headerText: "Debit",
      template: debitCol,
      width: "100",
      textAlign: "right",
    },
    {
      field: "note",
      headerText: "Note",
      width: "200",
      textAlign: "left",
    },
  ];

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Journal");
  };

  useEffect(() => {
    async function fetchData() {
      if (journal_id) {
        TimeoutUtility.resetTimeout();
        await getJournalById(journal_id)
          .then((resp) => {
            const ledgs = resp.data.map((item) => ({
              account_id: item.account_id,
              account: item.account,
              open_datetime: item.datetime,
              amount: item.amount,
              type_id: item.type_id,
              type: item.type,
              note: item.notes,
            }));
            setJournals(ledgs || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [journal_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW JOURNAL" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} style={{ padding: "0", justifyContent: "center" }}>
            <Col md={8} className="container-col">
              <GridComponent
                className="custom-grid"
                dataSource={Journals}
                height="calc(48vh - 60px)"
                allowSorting
                allowResizing
                rowHeight={36}
              >
                <ColumnsDirective>
                  {customersGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
                <Inject services={[Resize, Sort]} />
              </GridComponent>
              <br />
              <br />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewJournal;
